import { PaziaInput, PaziaInputProps } from "components/atoms";
import { minutesToTime } from "utils";
import React from "react";
import { useFormContext } from "react-hook-form";

export interface PaziaTimeInputProps extends Omit<PaziaInputProps, "type"> {}

export const PaziaTimeInput = ({ name, ...rest }: PaziaTimeInputProps): JSX.Element => {
  const { setValue } = useFormContext();

  const onBlurHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = isNaN(Number(e.target.value)) ? e.target.value : minutesToTime(e.target.value);
    // TODO e.target.value invalid string
    rest.onBlur?.(e);
    setValue(name, timeValue, { shouldDirty: true });
  };

  return <PaziaInput name={name} {...rest} onBlur={onBlurHandler} />;
};
